import React from 'react';
import { useLocale } from '@devsisters/gatsby-plugin-i18n';

const IndexPage: React.FC = () => {
  const locale = useLocale();
  React.useEffect(() => {
    location.href = `https://game.devsisters.com/${locale}/hellobravecookies/`;
  }, []);
  return null;
};
export default IndexPage;
